import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de médico). */
export type OficioDeferimentoPjJob = ReportJob;
export type OficioDeferimentoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do Ofício de Deferimento PJ. */
@Injectable({ providedIn: 'root' })
export class OficioDeferimentoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'oficio-deferimento-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.oficioDeferimentoPj;
}
